/**
 * Page shell for the Developer section (/dev): API docs plus one installation
 * guide per plugin. All tabs share the developer-tools permission.
 */
import { DashboardResources } from '@src/types';
import SectionTabShell, { type SectionTab } from '@src/components/SectionTabShell';
import { PLUGIN_GUIDES } from './guides';

export const DEVELOPER_TABS: SectionTab[] = [
  { value: DashboardResources.ApiDocs, label: 'API docs' },
  ...PLUGIN_GUIDES.map(({ resource, label }) => ({ value: resource, label })),
].map(({ value, label }) => ({ value, label, path: `/${value}`, resource: value }));

interface DeveloperTabShellProps {
  /** Resource name of the active tab, e.g. 'dev/docs'. */
  tab: string;
  children: React.ReactNode;
}

const DeveloperTabShell = ({ tab, children }: DeveloperTabShellProps) => (
  <SectionTabShell
    title="Developer"
    description="API reference and step-by-step guides for adding Trove plugins to your website."
    tabs={DEVELOPER_TABS}
    tab={tab}
  >
    {children}
  </SectionTabShell>
);

export default DeveloperTabShell;
